<template>
  <resource-base
      :ref="resourceBaseRef"
      :loading-display="false"
      :is-management-mode="false"
      :display-activity="false"
      :display-settings="false"
      :resource="resource"
      :settings="settings"
      @appLog="appLog"
      @settings-gen-changed="handleSettingsGenChange"
      @update-settings="handleUpdateSettings"
      style="background-color: #2b2c2e"
  >
    <template v-slot:display>
      <b-container fluid="xl">
        <display
            :resource="resource"
            :settings="settings"
            :user-data="userData"
            @user-clicked-about="handleUserClickedAbout"
            @appLog="appLog"
        />
      </b-container>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" />
    </template>
    <template v-slot:settings>
      <settings
          :resource="resource"
          :settings="settings"
          @resource-updated="handleRefreshResource"
          @update-user-data="handleUpdateUserData"
      />
    </template>
  </resource-base>
</template>

<script>
import ResourceBase from "../resourceBase";
import ResourceBlockIndex from "@/mixins/resourceBlocks/Index";
import Display from "./sections/display";
import Activity from "./sections/activity";
import Settings from "./sections/settings";
import themesJSON from "./assets/json/themes.json";
import {mapGetters} from "vuex";
export default {
  name: "Resource_MyAppStore",
  mixins: [ResourceBlockIndex],
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  },
  created() {
    this.appSetUp.useStyleClass = "none";
    this.handleSetUp();
  },
  mounted() {},
  computed: {
    ...mapGetters({
      userProfile: "user/profile"
    }),
    searchedResources() {
      if (this.searchStr.trim() == "") return this.storeItems;

      let searchRes = this.storeItems.filter(anItem => {
        return this.searchStr && anItem && anItem[this.name]
            ? anItem[this.name]
                .toLowerCase()
                .includes(this.searchStr.toLowerCase().trim())
            : "";
      });

      return searchRes;
    },
    filteredItems() {
      let filteredResources = this.storeItems.filter(anItem => {
        let check = true;
        this.activeTags.forEach(tag => {
          if (!anItem.tags.includes(tag.toLowerCase())) check = false;
        });
        return check;
      });
      let result = filteredResources;

      if (this.shallFilterOutUserOwnedItems) {
        result = this.filterOutUserOwnedItems(filteredResources);
      }
      return result;
    }
  },
  methods: {
    appLog(data) {
      //Use Mixins
      this.$emit("appLog", data);
    }
  },
  data() {
    return {
      appSetUp: {
        useStyleClass: 'none',
        bgImgURL:
          "https://images.unsplash.com/photo-1502987846294-e7ec70f4b393?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1373&q=80"
      },
      show: false,
      title: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder"
    };
  }
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}
</style>
